module.exports = __webpack_public_path__ + "img/login-image.75704da6.png";